import { OfferDetails, PaymentOption } from '@domgen/dgx-fe-basket';
import { CheckoutCompletedOfferConfirmation } from '../checkout-completed-item/checkout-completed-offer-confirmation.interface';

export interface CompletedOfferDetails
  extends OfferDetails,
    CheckoutCompletedOfferConfirmation {
  purchasedPaymentOption: PaymentOption;
}
